export const AdminModalTypes = {
  REQUEST_SKU: 'requestSKU',
  REQUEST_TRIAL: 'requestTrial'
};